import logo from "../assets/logo.png";

export default function Footer() {
    return (
        <footer className="footer">
            <div className="footer-grid">
                {/* Left: Logo & Contact */}
                <div className="footer-left">
                    <div className="footer-logo">
                        <img
                            src={logo}
                            alt="Shift Left Services Logo"
                            className="site-logo"
                        />
                    </div>
                </div>

                {/* Right: Social */}
                {/* <div className="footer-social">
                    <div>Follow Us On:</div>
                    <div className="footer-icons">
                        <a href="/" aria-label="LinkedIn">
                            <span role="img" aria-label="LinkedIn">
                                🔗
                            </span>
                        </a>
                        <a href="/" aria-label="Facebook">
                            <span role="img" aria-label="Facebook">
                                📘
                            </span>
                        </a>
                        <a href="/" aria-label="Twitter">
                            <span role="img" aria-label="Twitter">
                                🐦
                            </span>
                        </a>
                    </div>
                </div> */}
            </div>
        </footer>
    );
}
